export enum IndirectlyAllocatedProject {
  GLOBAL_TREES = 'GLOBAL_TREES',
  LANDSCAPE_RESTORATION = 'LANDSCAPE_RESTORATION',
}

export enum ImpactFund {
  UK_CLIMATE_NATURE_FUND = 'UK_CLIMATE_NATURE_FUND',
  FORESTS_LANDSCAPES_FUND = 'FORESTS_LANDSCAPES_FUND',
  BAFTA_FUND = 'BAFTA_FUND',
  FLIGHTS_OFFSET_FUND = 'FLIGHTS_OFFSET_FUND',
}

export const ProjectMix = { ...IndirectlyAllocatedProject, ...ImpactFund };
export type ProjectMix = IndirectlyAllocatedProject | ImpactFund;
